import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Header from './../../Layout/Header1';
import Footer from './../../Layout/Footer1';
import PageTitle from './../../Layout/PageTitle';
import SectionCounter from './../../Element/SectionCounter';
import TestimonialCarousel from './../../Element/TestimonialCarousel';
import FormStyle from './../../Element/FormStyle';

//Images
import bnr1 from './../../../images/banner/bnr4.jpg';
import bgmap from './../../../images/background/bg-map.jpg';
import bg1 from './../../../images/background/bg1.jpg';
import about from './../../../images/about/pic3.jpg';

const iconWraper=[
	{icon: <i className="flaticon-support" />, title:'Transactional SMS'},
	{icon: <i className="flaticon-email" />, title:'Promotional SMS'},
	{icon: <i className="flaticon-layers" />, title:'Scrubed Messages'},
	{icon: <i className="flaticon-mind" />, title:'OTP SMS Messages'},
	{icon: <i className="flaticon-chat" />, title:'API\'s SMS Messages'},
	{icon: <i className="flaticon-internet" />, title:'SIM Based Messages'},
];

const titleBlog=[
	{title1:'No Upfront Contracts', title2: 'or Hidden Fees', para: 'Your first 25 messages are free and you don\'t have to input any card details to use your free credit. Price does not increase alongside the size of your database - send SMS how you want and only pay for what you use.'}, 
	{title1:'Not Another Software', title2: 'Subscription!', para: 'No, whiteBing is pay-as-you-use, you\'re not paying when you\'re not using. So don\'t worry about yet another monthly subscription that you forget about and keep on paying.'}, 
	{title1:'100% Uptime', title2: 'SLA Guarantee', para: 'We’re so confident in our reliability, we offer a 100% uptime SLA guarantee so you can be sure your message reaches when you need it to.'}, 
	{title1:'Don\'t Stress About', title2: 'Message Deliverability', para: 'Not only is our service always up and running, but we use direct routes. So rest assured when you click send your messages are being delivered on time, every time via the quickest route.'}, 
	{title1:'Free 24/7 Support', title2: '365 Days', para: 'Talk to us through live chat, phone, contact form or email. There’s always a human on the other end, ready to help.'}, 
	{title1:'Relax, Help Is', title2: 'Always At Hand', para: 'Our global 24/7 chat is industry leading and we\'re proud to employ real humans in support to help our real humans in use. We understand businesses can require quick, efficient support at any time of the day or night.'}, 
];

class MessagingSolutions extends Component {


    render() {
        return (
            <>
                <Header />

                <div className="page-content bg-white">
                    {/* <!-- inner page banner --> */}
                    <div className="dlab-bnr-inr overlay-primary" style={{ backgroundImage: "url(" + bnr1 + ")" }}>
                        <PageTitle motherMenu='Messaging Solutions' activeMenu='Messaging Solutions' />
                    </div>
                    {/* <!-- inner page banner END --> */}
                    <div className="content-block">
                        {/* <!-- About Us --> */}
                        <div className="section-full content-inner exp-services">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="section-head text-black text-center">
                                            <h4 className="text-gray-dark font-weight-500 m-b10">Messaging Solutions</h4>
                                            <h2 className="box-title m-tb0">Scalable, interactive & custom SMS solutions on your way<span className="bg-primary"></span></h2>
                                            <p className="font-weight-300 font-18">Get started quickly by sending <strong className="text-primary">SMS</strong> messages via our web portal or integrate SMS into your everyday activities via our world-class <strong className="text-yellow">API's</strong> SMS is <strong className="text-red">Low-Cost</strong> and has higher read rates than other channels. <strong className="text-pink">Instant</strong> and timely engagement with your customers target your customers in <strong className="text-blue">real-time</strong> to achieve valuable business outcomes.</p>
                                        </div>
                                        <div className="row serv">
											{iconWraper.map((data,index)=>(	
												<div className="col-lg-2 col-md-4 col-sm-6 m-b30" key={index}>
													<div className="icon-bx-wraper expertise  bx-style-1 p-lr10 p-tb20 center">
														<div className="icon-bx-sm bg-primary radius m-b20">
															<Link to={"#"} className="icon-cell">{data.icon}</Link>
														</div>
														<div className="icon-content">
															<h5 className="dlab-tilte"><Link to={"#"}>{data.title}</Link></h5>
														</div>
													</div>
												</div>
											))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- Our Services --> */}
                        {/* <!-- About Us --> */}
                        <div className="section-full">
                            <div className="container-fluid">
                                <div className="row dzseth">
                                    <div className="col-lg-6 col-md-12 p-a0 img-fix">
                                        <img src={about} alt="" className="img-cover" />
                                    </div>
                                    <div className="col-lg-6 col-md-12 bg-black-light p-lr0 dis-tbl">
                                        <div className="p-a30 dis-tbl-cell ">
                                            <div className="max-w500 m-auto p-tb30">
                                                <div className="row">
                                                    <div className="col-lg-12 text-white">
                                                        <h3 className="box-title m-b10">Send Better, Smarter, <br/>More Integrated SMS Messages.<span className="bg-primary"></span></h3>
                                                        <h5 className="m-b30">We make it easy, fast and affordable to send SMS marketing campaigns or engage in 1-on-1 conversations with customers.</h5>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-12 m-b30 chosesus-content">
                                                        <ul className="list-checked primary text-white">
                                                            <li><span>Easy Integration, Scalable and Reliable.</span></li>
                                                            <li><span>The Trusted Leader in Text Marketing.</span></li>
                                                            <li><span>No Upfront Contracts or Fees. Uptime SLA Guarantee 100%.</span></li>
                                                        </ul>
                                                        <p>We’re so confident in our reliability, we offer a 100% uptime SLA guarantee so you can be sure your message reaches when you need it to.</p>
                                                        <p className="list-checked primary text-white">Talk to us through live chat, phone, contact form or email. There’s always a human on the other end, ready to help.</p>
                                                        <Link to={"#"} className="site-button radius-xl outline white">Read More <i className="fa fa-long-arrow-right"></i></Link>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- About Us End --> */}
                        {/* <!-- About Us --> */}
                        <div className="section-full content-inner">
                            <div className="container">
                                <div className="section-head text-black text-center">                                
                                    <h2 className="box-title m-tb0">Why Choose <strong className="text-blue">whiteBing </strong>for Your Messaging Partner<span className="bg-primary"></span></h2>
                                    <p>The relentless attention to detail shines through in every area of our platform. We've spent a countless number of hours building and perfecting a powerful SMS Application service that's easy to use and works wonderfully on all your devices.</p>
                                </div>
                            </div>
                            <div className="container">
                                <div className="row ">
									{titleBlog.map((data,index)=>(
										<div className="col-lg-4 col-md-6 col-sm-6 m-b30" key={index}>
											<div className="icon-bx-wraper expertise  bx-style-1 p-a30 center">
												<div className="icon-content">
													<h4 className="dlab-tilte text-uppercase"><Link to={"#"}>{data.title1}	<br/>{data.title2}</Link></h4>
													<p>{data.para}</p>
													<Link to={"#"} className="site-button radius-xl outline outline-2">Read Move</Link>
												</div>
											</div>
										</div>
									))}                                    
                                </div>
                            </div>
                        </div>
                        {/* <!-- Our Services --> */}
						{/* <!-- Why Chose Us --> */}
							<SectionCounter />
                        {/* <!-- Why Chose Us End --> */}
                        {/* <!-- Testimonials --> */}
                        <div className="section-full content-inner"   style={{ backgroundImage: "url(" + bgmap + ")", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
                            <div className="container">
                                <div className="section-head text-center">
                                    <h2 className="box-title m-tb0">Our Testimonials<span className="bg-primary"></span></h2>
                                    <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the </p>
                                </div>
                                <div className="section-content m-b30 ">
									<TestimonialCarousel /> 
                                </div>
                            </div>
                        </div>
                        {/* <!-- Testimonials END --> */}
                        {/* <!-- Get in touch --> */}
                        <div className="section-full overlay-primary-dark bg-img-fix" style={{ backgroundImage: "url(" + bg1 + ")" }}>
                            <FormStyle />
                        </div>
                        {/* <!-- Get in touch --> */}
                    </div>
                    {/* <!-- contact area END --> */}
                </div>

                <Footer />
            </>
        )
    }
}
export default MessagingSolutions;